import { Link } from "react-router-dom";
import TabOnboardingCompliance from "components/__new/common/TabOnboardingCompliance";
import successGif from "assets/images/icons/success-green.gif";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";


const OnboardingComplianceCacSuccess = () => {
    
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="CAC Compliance"
            />
            
            <div className="py-14">
                <TabOnboardingCompliance index="2" />
            </div>
            
            <div className="box">
                <div className="mx-auto my-8 max-w-xs text-center">
                    
                    <div className="w-60 h-60 mx-auto flex items-center justify-center">
                        <img src={successGif} alt="Success" className="object-contain" />
                    </div>
                    
                    <div className="mt-0">
                        <div className="font-bold text-2xl">
                            Success
                        </div>
                        <div className="mt-2 text-sm text-[#374151]">
                            CAC Status report submitted successfully
                        </div>
                    </div>
                    
                    <div className="mt-8 flex justify-between">
                        <Link to="/dashboard" className="btn btn-block btn-ep-primary btn-lg">
                            Refresh Dashboard 
                        </Link>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}


export default OnboardingComplianceCacSuccess;